import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { customNoAuthAxios } from '../../utils/customNoAuthAxios';
import { customAuthAxios } from '../../utils/customAuthAxios';
import { useSuccessToast } from '../toast/useSuccessToast';
import { useErrorToast } from '../toast/useErrorToast';

export const useEditRestaurant = () => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const showErrorToast = useErrorToast();

  const onSubmit = useCallback(async (
      userId: string,
      restaurantId: string,
      data: any
  ) => {
    try {
      // ユーザー情報の更新
      await customNoAuthAxios.put(`accounts/other-user/${userId}/`, data.user);

      // 店舗情報の更新
      const restaurantData = data.restaurant;
      const uploadData = new FormData();
      const fields = [
        "name",
        "address",
        "manager_last_name",
        "manager_first_name",
        "manager_phone_number"
      ];

      fields.forEach(field => uploadData.append(field, restaurantData[field]));

      if (restaurantData.logo?.[0]) {
        uploadData.append("logo", restaurantData.logo[0], restaurantData.logo[0].name);
      }

      uploadData.append("plan_id", restaurantData.plan);

      if (restaurantData.add_ons?.length) {
        restaurantData.add_ons.forEach((addOnId: string) =>
            uploadData.append("add_ons", addOnId)
        );
      } else {
        uploadData.set("add_ons", JSON.stringify(null));
      }

      await customAuthAxios.put(`accounts/restaurants/${restaurantId}/`, uploadData);

      showToast('変更が完了しました');
      navigate(-1);
    } catch (error: any) {
      if (error.response?.data?.username) {
        showErrorToast(error.response.data.username);
      } else {
        showErrorToast('更新中にエラーが発生しました');
      }
    }
  }, [navigate, showToast, showErrorToast]);

  return onSubmit;
};